// extracted by mini-css-extract-plugin
module.exports = {"miniLegendRoot":"ubIxlJbR","item":"JS9o1KE5","dot":"JyVIMQj0","label":"bQliC76b"};